import React, { useState } from "react";

export function Tabs({ children }) {
  function findActiveTab(a) {
    return a.reduce((accumulator, currentValue, i) => {
      if (currentValue.props.active) {
        return i;
      }

      return accumulator;
    }, 0);
  }

  function tabValidator(tab) {
    return tab.type.displayName === "Tab" ? true : false;
  }

  const [activeTab, setActiveTab] = useState(findActiveTab(children));
  return (
    <>
      <div className="w-full flex gap-4 justify-start px-[2px]  ">
        {children.map((item, i) => {
          return (
            <>
              {tabValidator(item) && (
                <Tab
                  key={`tab-{i}`}
                  currentTab={i}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                >
                  {item.props.children}
                </Tab>
              )}
            </>
          );
        })}
      </div>
      <div className="px-[2px]  w-full ">
        {children.map((item, i) => {
          return (
            <div className={` ${i === activeTab ? "visible" : "hidden"}`}>
              {item.props.component}
            </div>
          );
        })}
      </div>
    </>
  );
}

export function Tab({ children, activeTab, currentTab, setActiveTab }) {
  return (
    <>
      <div
        className={` pb-1 pt-2  cursor-pointer
      ${activeTab === currentTab ? "" : ""} bg-white text-xs font-semibold`}
        onClick={() => setActiveTab(currentTab)}
        style={activeTab === currentTab ?{borderBottom:"4px solid #119DEE"}:{borderBottom:"4px solid transparent"}}
      >
        {children}
      </div>
    </>
  );
}

Tab.displayName = "Tab";
